module.exports = __webpack_public_path__ + "img/login_box_bg.d64589ee.png";